import http from './http'

// 获取列表
export function pageList (queryString) {
  return http.get(`/user/order/rebate/user/pagelist?${queryString}`)
}

// 获取列表
export function pageRebateList (queryString) {
  return http.get(`/user/order/rebate/pagelist?${queryString}`)
}

export function removeRebateList (key) {
  return http.delete('/user/order/rebate?key=' + key)
}

// 获取列表
export function pageRebateWithdrawalList (queryString) {
  return http.get(`/user/order/rebate/withdrawal/pagelist?${queryString}`)
}

export function withdrawalRequest (data) {
  return http.post('/user/order/rebate/withdrawal', data)
}

export function withdrawalConfig () {
  return http.get('/user/order/rebate/withdrawal/get_config')
}

export function withdrawalConfigUpdate (data) {
  return http.post('/user/order/rebate/withdrawal/config', data)
}
